// Transmission format yyyy-MM-ddThh:mm:ss
// UI Date dd/MM/yyyy
// UI time format


export function dispayDateAndTimeToTransmissionDate(displayableDate: string, displayableTime : string) : string {
    if (!displayableDate) { 
        displayableDate = '0000-01-01'
    }
    if (!displayableTime) {
        displayableTime = '00:00'
    }
    let d : number = 0
    let m : number = 0
    let y : number = 0
    let h : number = 0
    let min : number = 0
    var dateArray = displayableDate.split('-')
    var timeArray = displayableTime.split(':')
    // No hyphens to split on, try '/'
    if (dateArray.length > 1) {
        
        if (dateArray.length>2 && timeArray.length>1) {
             d = parseInt(dateArray[2])
             m = parseInt(dateArray[1])
             y = parseInt(dateArray[0])
             h = parseInt(timeArray[0])
             min = parseInt(timeArray[1])
        
        }
    }
    else {
        dateArray = displayableDate.split('/')
        if (dateArray.length>2 && timeArray.length>1) {
             d = parseInt(dateArray[0])
             m = parseInt(dateArray[1])
             y = parseInt(dateArray[2])
             h = parseInt(timeArray[0])
             min = parseInt(timeArray[1])

        }
    }

    return formatNumberAs4Digits(y) + '-' + formatNumberAs2Digits(m) + "-" + formatNumberAs2Digits(d) + 'T' + formatNumberAs2Digits(h) + ':'+ formatNumberAs2Digits(min) + ':00' 


}

export function transmissionDateToDisplayableDateTime(transmissionDateTime : string) {
    
    var date = new Date(transmissionDateTime);
    return dateToDisplayableDateTime(date);
}
export function transmissionDateToInputDate(transmissionDateTime : string) {
    
    var date = new Date(transmissionDateTime);
    return dateToInputDate(date);
}
export function transmissionDateToDisplayableDate(transmissionDateTime : string) {
    var date = new Date(transmissionDateTime);
    return dateToDisplayableDate(date);
}
export function transmissionDateToDisplayableTime(transmissionDateTime : string) {
    var date = new Date(transmissionDateTime);
    return dateToDisplayableTime(date);
}
export function dateToDisplayableDateTime (dt : Date) {
    var dd = dt.getDate()
    var mm = dt.getMonth() + 1
    var yy = dt.getFullYear()
    var hh = dt.getHours()
    var min = dt.getMinutes()
    var result = `${ formatNumberAs2Digits(dd)}/${formatNumberAs2Digits(mm)}/${formatNumberAs4Digits(yy)} ${formatNumberAs2Digits(hh)}:${formatNumberAs2Digits(min)}`
    return result;
}
export function dateToTransmissionDateTime (dt : Date) {
    var dd = dt.getDate()
    var mm = dt.getMonth() + 1
    var yy = dt.getFullYear()
    var hh = dt.getHours()
    var min = dt.getMinutes()
    var result = `${formatNumberAs4Digits(yy)}-${ formatNumberAs2Digits(mm)}-${formatNumberAs2Digits(dd)}T${formatNumberAs2Digits(hh)}:${formatNumberAs2Digits(min)}:00`
    return result;
}
export function dateToInputDate (dt : Date) {
    var dd = dt.getDate()
    var mm = dt.getMonth() + 1
    var yy = dt.getFullYear()
    var result = `${formatNumberAs4Digits(yy)}-${formatNumberAs2Digits(mm)}-${ formatNumberAs2Digits(dd)}`
    return result;
}

export function dateToDisplayableDate (dt : Date) {
    var dd = dt.getDate()
    var mm = dt.getMonth() + 1
    var yy = dt.getFullYear()
    var result = `${ formatNumberAs2Digits(dd)}/${formatNumberAs2Digits(mm)}/${formatNumberAs4Digits(yy)}`
    return result;
}

export function dateToDisplayableTime (dt : Date) {
    var hh = dt.getHours()
    var min = dt.getMinutes()
    var result = `${formatNumberAs2Digits(hh)}:${formatNumberAs2Digits(min)}`
    return result;
}

function padLeft(numberValue : number, padChar : string, size:number): string {
    let result: string = numberValue + "";
    while(result.length < size)
        result = padChar + result;
    return result;
}

function formatNumberAs2Digits(numberValue : number) {
    return padLeft(numberValue, "0",2)
}

function formatNumberAs4Digits(numberValue : number) {
    return padLeft(numberValue, "0",4)
}